import type { CommentNode } from './types';

/** Nest a flat, chronologically-ordered comment list by `parentId`. */
export function buildTree(flat: CommentNode[]): CommentNode[] {
  const byId = new Map<string, CommentNode>();
  for (const node of flat) byId.set(node.id, { ...node, replies: [] });

  const roots: CommentNode[] = [];
  for (const node of byId.values()) {
    const parent = node.parentId ? byId.get(node.parentId) : undefined;
    if (parent) parent.replies.push(node);
    else roots.push(node);
  }
  return roots;
}

/** Immutably flip like state for one comment anywhere in the tree (optimistic UI). */
export function toggleLikeInTree(nodes: CommentNode[], id: string): CommentNode[] {
  return nodes.map((node) => {
    if (node.id === id) {
      return {
        ...node,
        likedByMe: !node.likedByMe,
        likeCount: node.likeCount + (node.likedByMe ? -1 : 1),
      };
    }
    if (node.replies.length > 0) return { ...node, replies: toggleLikeInTree(node.replies, id) };
    return node;
  });
}
